module.exports = "<div id=\"content\" class=\"content\" #scaleableContent>\n    <div #contentContainer></div>\n</div>\n"